export function getCountries(state) {
  return state?.enabled || []
}

export function getCountry(state, countryCode) {
  const countries = state.enabled || []
  return countries.find(country => country.alpha2 === countryCode)
}

export function getAllCountries(state) {
  return state?.all || []
}
